import React, { useCallback } from 'react';
import classNames from 'classnames';
import { TriggerSidePaneQuestions } from './TriggerSidePaneQuestions/TriggerSidePaneQuestions';
import { qAndATriggersSelector } from '@mm/state/selectors/triggerSelectors';
import { activeChatbotIdSelector } from '@mm/state/selectors/viewSelectors';
import { useDispatch, useSelector } from 'react-redux';
import { Dispatch } from 'redux';
import { StoreState } from '@mm/state/store-interfaces';
import suggestionsCRUDActions from '@mm/state/actions/SuggestionsCRUDActions';
import { filterSuggestions } from '../../common/suggestions';

type Props = {
  className?: string;
};

export const TriggerSidePane = ({ className }: Props) => {
  const dispatch: Dispatch<StoreState> = useDispatch();

  const activeChatbotId = useSelector(activeChatbotIdSelector);
  const triggers = useSelector(qAndATriggersSelector);
  const suggestions = useSelector(
    (state: StoreState) => state.suggestion?.entities,
  );
  const suggestionsLoading = useSelector(
    (state: StoreState) => state.suggestion?.loading,
  );

  const onIgnore = useCallback(
    id => {
      dispatch(suggestionsCRUDActions.discountSuggestion(activeChatbotId, id));
    },
    [activeChatbotId],
  );

  const questions = filterSuggestions(triggers, suggestions);

  return (
    <div className={classNames(className, 'trigger-side-pane')}>
      <div className="trigger-side-pane__item">
        <TriggerSidePaneQuestions
          loading={suggestionsLoading}
          questions={questions}
          onIgnore={onIgnore}
        />
      </div>
    </div>
  );
};
